(function () {
    'use strict';
    angular
        .module('app.performanceReturnOnInvestmentReport')
        .directive('performanceReturnOnInvestmentReportDirective', function () {
                return {
                    controller: 'performanceReturnOnInvestmentReportCtrl',
                    templateUrl: 'app/measure/performanceReport/performanceReturnOnInvestmentReport/performanceReturnOnInvestmentReport.html?app_v=deployDate',
                    restrict: 'E',
                    scope: {
                    },
                    replace: true,
                    transclude: true
                };
            })
})();